import appendUrlParam from '~/utils/appendUrlParam'

export const state = () => ({
  isCanceling: false,
  isCancelSuccess: false,
})

export const mutations = {
  cancelOrderRequest(state) {
    state.isCanceling = true
    state.isCancelSuccess = false
  },
  cancelOrderSuccess(state) {
    state.isCanceling = false
    state.isCancelSuccess = true
  },
  cancelOrderFailure(state, error) {
    state.isCanceling = false
  },
  resetCancelState(state) {
    state.isCanceling = false
    state.isCancelSuccess = false
  },
}

export const actions = {
  async submitCancelOrder({ commit }, { storeInfo, orderNumber, resetCancel }) {
    commit('cancelOrderRequest')
    await this.$axios.$put(
      appendUrlParam(`/orders/${orderNumber}/cancel`, {
        ...storeInfo,
        reset_cancel: resetCancel,
      })
    )
    commit('cancelOrderSuccess')
  },
  resetCancelState({ commit }) {
    commit('resetCancelState')
  },
  cancelOrderFailure({ commit }, error) {
    commit('cancelOrderFailure', error)
  },
}

export const getters = {
  isCanceling: (state) => state.isCanceling,
  isCancelSuccess: (state) => state.isCancelSuccess,
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
